/**
 * Cover constructor
 * @constructor app.editor.stage.Cover
 */
fx.ns("shared.stage", class CalendarSingleArea extends shared.stage.CalendarArea {

    constructor(cover, model, parentContainer, side) {
        super(cover, model, parentContainer, side);
    }

    get single() {
        return true;
    }
    /***************** Getters / Setters *****************/

    get cover() {
        return this.data;
    }

    get areaHeight() {
        return this.calendar.pageHeight;
    }

    get areaWidth() {
        return this.calendar.pageWidth;
    }

    get pageHeight() {
        return this.calendar.pageHeight;
    }

    // return active part of pages : left / right / center (for slice)
    get activePart() {
        return this._activePart;
    }

    set activePart(val) {
        this._activePart = val;

        this.background.toggleClass("active", val == "top");
    }

    get active() {
        return super.active;
    }

    set active(val) {
        super.active = val;

        this.activePart = val ? "top" : "";
    }

    refresh() {

    }


    create() {
        super.create(true);

        if (!this.rawDisplay) {
            this.container = new fx.components.Box("Container");
            this.addChild(this.container, { width: "100%", height: "100%" });

            // backgrounds
            this.background = new fx.components.Box("background");
            this.background.pointerEvents = false;
            this.container.addChild(this.background);

            //this.backgroundBottom = new fx.components.Box("background-right");
            //this.backgroundBottom.pointerEvents = false;
            //this.container.addChild(this.backgroundBottom);

            if (this.calendar.hasHook) {
                this.hook = new fx.components.Box("hook");
                this.hook.pointerEvents = false;
                this.container.addChild(this.hook, { left: "center", top: -10, width: 20, height: 20 });
            }

            this.binding = new shared.stage.CoverBinding(this.calendar, this.data);

            this.binding.pointerEvents = false;
            this.container.addChild(this.binding, { left: 0, top: 0, width: "100%", height: 10 });

        }
    }

    updateCoverBindingPosition() {
        let elements = fx.dom.find(".CoverBinding .content .element .asset");
        if (elements) {
            if (elements.length > 0) {
                const top = -3 * this.calendar.extraScale;
                elements.forEach(el => {
                    el.style.top = top + "px";
                });
            }
        }
        elements = fx.dom.find(".CoverBinding .content .wall-single .asset");
        if (elements) {
            if (elements.length > 0) {
                const top = -10 * this.calendar.extraScale;
                elements.forEach(el => {
                    el.style.top = top + "px";
                });
            }
        }
    }

    /***************** Actions *****************/


    /*updateChildPositions() 
    {
        super.updateChildPositions();		
    }
*/
    updateSidePositions() {
        if (!this.initialized || !this.page) return;

        this.height(this.calendar.pageHeight);

        this.container.height(this.calendar.pageHeight);

        this.background.show();
        this.background.width(this.calendar.pageWidth);
        this.background.height(this.calendar.pageHeight);
        this.background.top(0);

        this.stageContainer.height(this.calendar.pageHeight);
        this.stageContainer.top(0);

        this.stage.height(this.calendar.pageHeight);
        this.stage.top(0);

        this.binding.top(0);
        //this.updateCoverBindingPosition();

    }

});